import { Injectable } from "@angular/core";
import { VexColorScheme } from "@vex/config/vex-config.interface";
import { VexConfigService } from "@vex/config/vex-config.service";

@Injectable({ providedIn: "root" })
export class ThemeService {
     
    private theme: 'light' | 'dark';
    
    constructor(
        private configService: VexConfigService,
    ) {
        this.theme = this.detectSystemTheme();
    }

    getTheme(): string {
        return this.theme
    }

    setTheme(theme: 'system' | 'light' | 'dark'): void {
        switch(theme) {
            case 'system':
                this.setSystemTheme();
                break;
            case 'light':
                this.setLightTheme();
                break;
            case 'dark':
                this.setDarkTheme();
                break;
            default:
                this.setSystemTheme();
                break;
        }
    }

    setLightTheme(): void {
        this.configService.updateConfig({
            style: {
              colorScheme: VexColorScheme.LIGHT
            }
        });
        this.theme = 'light';
    }

    setDarkTheme(): void {
        this.configService.updateConfig({
            style: {
              colorScheme: VexColorScheme.DARK
            }
        });
        this.theme = 'dark'
    }

    detectSystemTheme(): 'light' | 'dark' {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            return 'dark'
        }
        return 'light'
    }

    setSystemTheme(): void {
        const theme = this.detectSystemTheme();
        switch(theme) {
            case 'light':
                this.setLightTheme();
                break;
            case 'dark':
                this.setDarkTheme();
                break;
        }
    }

  
}


